module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.imageClass, _vm.imageState],
    style: (_vm.computedStyle),
    attrs: {
      "data-width": _vm.imageWidth,
      "data-height": _vm.imageHeight,
      "data-state": _vm.imageState
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5be9a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-lazy-background-images/VueLazyBackgroundImage.vue
// module id = 8
// module chunks = 0